import React from 'react';
import './heading.scss';
export var Heading = function (_a) {
    var level = _a.level, title = _a.title, mb = _a.mb, extendClass = _a.extendClass;
    var HeadingLevel = level;
    var classes = "c-heading c-heading--".concat(level);
    if (mb) {
        classes += " u-mb-".concat(mb);
    }
    if (extendClass) {
        classes += " ".concat(extendClass);
    }
    return React.createElement(HeadingLevel, { className: classes }, title);
};
